"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Spinner = require("../Spinner");

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VoucherOrderPaymentPanel = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(VoucherOrderPaymentPanel, _Component);

  function VoucherOrderPaymentPanel() {
    (0, _classCallCheck3.default)(this, VoucherOrderPaymentPanel);
    return (0, _possibleConstructorReturn3.default)(this, (VoucherOrderPaymentPanel.__proto__ || (0, _getPrototypeOf2.default)(VoucherOrderPaymentPanel)).apply(this, arguments));
  }

  (0, _createClass3.default)(VoucherOrderPaymentPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.confirmPayment({
        data: this.queryToLowercase(),
        orderId: this.props.orderId
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "row" },
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(_Spinner2.default, null),
          _react2.default.createElement(
            "p",
            null,
            "Varmistetaan maksua.."
          )
        )
      );
    }
  }, {
    key: "queryToLowercase",
    value: function queryToLowercase() {
      var query = this.props.query;

      return (0, _keys2.default)(query).reduce(function (a, k) {
        a[k.toLowerCase()] = query[k];
        return a;
      }, {});
    }
  }]);
  return VoucherOrderPaymentPanel;
}(_react.Component), _class.propTypes = {
  orderId: _react.PropTypes.number.isRequired,
  confirmPayment: _react.PropTypes.func.isRequired,
  query: _react.PropTypes.object.isRequired
}, _temp);
exports.default = VoucherOrderPaymentPanel;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/vouchers/VoucherOrderPaymentPanel.js
 ** module id = 488
 ** module chunks = 0
 **/